import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsLoading(false);
      return;
    }
    apiService
      .getProfile()
      .then((profile) => setUser(profile))
      .catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        apiService.clearToken();
      })
      .finally(() => setIsLoading(false));
  }, []);

  const login = (authResponse) => {
    localStorage.setItem("token", authResponse.jwt);
    localStorage.setItem("user", JSON.stringify(authResponse));
    apiService.setToken(authResponse.jwt);
    setUser(authResponse);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    apiService.clearToken();
    setUser(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
